export const LoadingPageHTML = `
<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Loading Game</title>
  </head>
  <style>
    body {
      background-image: url('assets/auth-bg.png');
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .loading {
      font-size: 50px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 800;
      text-align: center;
    }
    .loading span {
      display: inline-block;
      margin: 0 -0.05em;
    }

    .loading span {
      animation: loadinAnim 0.7s infinite;
    }
    .loading span:nth-child(2) {
      animation-delay: 0.1s;
    }
    .loading span:nth-child(3) {
      animation-delay: 0.2s;
    }
    .loading span:nth-child(4) {
      animation-delay: 0.3s;
    }
    .loading span:nth-child(5) {
      animation-delay: 0.4s;
    }
    .loading span:nth-child(6) {
      animation-delay: 0.5s;
    }
    .loading span:nth-child(7) {
      animation-delay: 0.6s;
    }

    @keyframes loadinAnim {
      0%,
      100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(15px);
      }
    }
  </style>
  <body>
    <div class="loading">
      <span>L</span>
      <span>O</span>
      <span>A</span>
      <span>D</span>
      <span>I</span>
      <span>N</span>
      <span>G</span>
    </div>
  </body>
</html>

`;
